import { Component } from '@angular/core';
import { BaseTooltip } from 'shared/abstract/base-tooltip';

@Component({
    selector: 'app-truncated-content-custom-tooltip',
    imports: [],
    templateUrl: './truncated-content-custom-tooltip.component.html',
    styleUrl: './truncated-content-custom-tooltip.component.scss',
})
export class TruncatedContentCustomTooltipComponent extends BaseTooltip {
    public data: any;

    protected clickInside(event: any) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }
}
